import React from "react";
import { MarketrsTable } from "../../UI/Marketers/MarketrsTable";
import PanelBody from "../../UI/Panel/PanelBody";
import PanelHead from "../../UI/Panel/PanelHead";

const Marketers = () => {
  return (
    <div>
      <PanelHead title="Marketer" />
      <PanelBody content={<MarketrsTable />} />
    </div>
  );
};

export default Marketers;
